import { useEffect, useState } from 'react'
import { UserPlansResponseInterface } from 'common/components/entities/price-element/price-element-interface'
import { getUserPlans } from 'publisher/api/price-element-api'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'

interface usePricePlansProps {
  locale: PageLocaleEnum
}

export const usePricePlans = ({ locale }: usePricePlansProps) => {
  const [pricePlans, setPricePlans] = useState<
    UserPlansResponseInterface[] | null
  >(null)
  const [error, setError] = useState<unknown>(null)
  const [isFetching, setIsFetching] = useState(false)

  const fetch = async () => {
    setIsFetching(true)
    try {
      const data = await getUserPlans({ locale })
      setPricePlans(data.data)
    } catch (error) {
      setError(error)
    } finally {
      setIsFetching(false)
    }
  }

  useEffect(() => {
    fetch()
  }, [])

  return { pricePlans, isFetching, error, fetch }
}
